<div class="bl-padding-sm--24 bl-text-align--center">
    <div class="bl-max-width--100 bl-margin-x--auto bl-margin-bottom--24">
        <img src="assets/images/warning-icon.svg" alt="" aria-hidden="true">
    </div>
    <h4 class="bl-font-size--base bl-font-color--steel bl-font-weight--900 bl-margin-bottom--16">
        {{'oaoMembershipChangeModal/heading' | dictionary}}
    </h4>
    <p class="bl-font-color--slate bl-margin-bottom--24">
        {{'oaoMembershipChangeModal/description' | dictionary}}
    </p>
    <div
        class="bl-display--block bl-display-sm--flex bl-flex-direction--row-reverse bl-justify-content--center bl-width-sm--75 bl-margin-x--auto bl-margin-top--32">
        <button type="button" id="changeMembership"
            (click)="confirmMembershipChange(); "
            class="bl-button bl-width--100 bl-margin-bottom--16 bl-margin-bottom-sm--0">{{'oaoMembershipChangeModal/confirm'
            | dictionary}}</button>
        <button type="button" id="custom-modal-close"
            (click)="cancelMembershipChangeModal()"
            class="bl-button bl-button-reverse bl-margin-right--24 bl-width--100">{{'oaoMembershipChangeModal/cancel' |
            dictionary}}</button>
    </div>
</div>